<div #termsContainer class="terms-container">
  <div class="terms-content">
    <div class="header">
      <img src="../../assets/logo.png" alt="Logo" class="logo" />
      <!-- <h1>{{ translations.termsAndConditions }}</h1> -->
    </div>

    <!-- Contract content -->
    @if (isLoading) {
      <div class="contract-loading">
        <mat-spinner diameter="36"></mat-spinner>
        <div class="loading-text">Loading contract...</div>
      </div>
    } @else {
      <div class="contract-content" [innerHTML]="safeContractContent"></div>
    }

    <!-- Agreement checkbox -->
    @if (!isLoading && !contractLoadError) {
      <div class="agreement-section">
        <mat-checkbox class="agreement-checkbox" [(ngModel)]="data.checked" (change)="onAgreementChange($event)" >
          <span class="red-text">{{ translations.agreementText }}</span>
        </mat-checkbox>
      </div>
    }

    <!-- Agreed By Field -->
    <!-- @if (data.checked) {
      <mat-form-field appearance="outline" class="capitalize-first agreed-by-field" >
        <mat-label> {{ translations.agreedBy }} </mat-label>
        <input matInput [formControl]="agreedBy" required (keydown.space)="$event.preventDefault()"
          [placeholder]="translations.agreedByPlaceholder || 'Enter your name'" />
        @if (agreedBy.invalid && agreedBy.touched) {
          <mat-error>{{ translations.agreedByRequired }}</mat-error>
        }
      </mat-form-field>
    } -->

    <!-- Navigation Buttons -->
    <div class="button-section">
      <!-- @if (showScrollTop) {
        <button mat-raised-button class="continue-btn" type="button" (click)="scrollToTop()"> ⬆ {{ translations.scroll }}</button>
      } -->

      <button mat-button (click)="goBack()" class="back-btn">{{ translations.back }}</button>

      @if (!contractLoadError && data.checked) {
        <button
          mat-raised-button
          class="continue-btn"
          type="button"
          [disabled]="!data.checked"
          (click)="openSignDialog()"
        >
          {{ translations.signNow }}
        </button>
      }
    </div>
  </div>
</div>
